/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Document } from '../../core/models/Document';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30SchemaDefinition } from '../../openapi/v3/models/Oas30SchemaDefinition';
import { ReplaceNodeCommand } from './ReplaceNodeCommand';

/**
 * A command used to replace a definition schema with a newer version.
 * @author eric.wittmann@gmail.com
 * @extends ReplaceNodeCommand
 * @class
 */
export class ReplaceSchemaDefinitionCommand_30 extends ReplaceNodeCommand<Oas30SchemaDefinition> {
    public _defName : string;

    public constructor(old? : any, replacement? : any) {
        if(((old != null && old instanceof <any>Oas30SchemaDefinition) || old === null) && ((replacement != null && replacement instanceof <any>Oas30SchemaDefinition) || replacement === null)) {
            let __args = arguments;
            super(old, replacement);
            if(this._defName===undefined) this._defName = null;
            if(this._defName===undefined) this._defName = null;
            (() => {
                this._defName = old.getName();
            })();
        } else if(old === undefined && replacement === undefined) {
            let __args = arguments;
            super();
            if(this._defName===undefined) this._defName = null;
            if(this._defName===undefined) this._defName = null;
        } else throw new Error('invalid overload');
    }

    public removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_v3_models_Oas30SchemaDefinition(doc : Document, node : Oas30SchemaDefinition) {
        let doc30 : Oas30Document = <Oas30Document>doc;
        doc30.components.removeSchemaDefinition(node.getName());
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#removeNode(io.apicurio.datamodels.core.models.Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {Oas30SchemaDefinition} node
     */
    public removeNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>Oas30SchemaDefinition) || node === null)) {
            return <any>this.removeNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_v3_models_Oas30SchemaDefinition(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    public addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_v3_models_Oas30SchemaDefinition(doc : Document, node : Oas30SchemaDefinition) {
        let doc30 : Oas30Document = <Oas30Document>doc;
        node._ownerDocument = doc;
        node._parent = doc30.components;
        doc30.components.addSchemaDefinition(node.getName(), node);
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#addNode(io.apicurio.datamodels.core.models.Document, io.apicurio.datamodels.core.models.Node)
     * @param {Document} doc
     * @param {Oas30SchemaDefinition} node
     */
    public addNode(doc? : any, node? : any) : any {
        if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null && node instanceof <any>Oas30SchemaDefinition) || node === null)) {
            return <any>this.addNode$io_apicurio_datamodels_core_models_Document$io_apicurio_datamodels_openapi_v3_models_Oas30SchemaDefinition(doc, node);
        } else if(((doc != null && doc instanceof <any>Document) || doc === null) && ((node != null) || node === null)) {
             throw new Error('cannot invoke abstract overloaded method... check your argument(s) type(s)'); 
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.ReplaceNodeCommand#readNode(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} doc
     * @param {*} node
     * @return {Oas30SchemaDefinition}
     */
    readNode(doc : Document, node : any) : Oas30SchemaDefinition {
        let doc30 : Oas30Document = <Oas30Document>doc;
        let definition : Oas30SchemaDefinition = doc30.components.createSchemaDefinition(this._defName);
        Library.readNode(node, definition);
        return definition;
    }
}
ReplaceSchemaDefinitionCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.ReplaceSchemaDefinitionCommand_30";
ReplaceSchemaDefinitionCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




